import React from "react";
import NestedDataTableRow from "./NestedDataTableRow";

import "../css/nested-datatable.css";

export default function NestedDataTable(props) {
  return (
    <div className="nested-datatable" id={props.id ? props.id : ""}>
      <div className="table-header">
        <span className="table-header-item"> </span>
        {props.mainColumns.map((col) => {
          return (
            <span key={col.name} className={"table-header-item " + col.size}>
              {col.name}
            </span>
          );
        })}
      </div>
      {props.data.map((el) => {
        return (
          <div key={el.idEmpresa}>
            <NestedDataTableRow
              data={el}
              nestedColumns={props.nestedColumns}
              openCompanyFunction={(id) => {
                props.openCompanyFunction(id);
              }}
              openOpticFunction={(id) => {
                props.openOpticFunction(id);
              }}
              newOpticFunction={(id) => {
                props.newOpticFunction(id);
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
